import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { injectRegisterIcons } from '@ngneat/svg-icon';
import { TranslatePipe } from '@ngx-translate/core';

import { RouteSegment } from '@core/enums/route-segment.enum';

import {
  EvseStatusStoreModelEnum,
  SiteTypeStoreModelEnum,
  VehicleOperationalStatusStoreModelEnum,
} from '@domain/single-site/single-site.enums';

import { DepotOverviewChartComponent } from '@shared/components/depot-overview-chart';
import { EvseStatusIconComponent } from '@shared/components/evse-status-icon';
import { IconButtonComponent } from '@shared/components/icon-button';
import { VehicleOperationalStatusIconComponent } from '@shared/components/vehicle-operational-status-icon';
import { TranslateEvseStatusCapitalizedPipe } from '@shared/pipes/translate-enum-pipes/translate-evse-status-capitalized.pipe';
import { TranslateVehicleStatusCapitalizedPipe } from '@shared/pipes/translate-enum-pipes/translate-vehicle-status-capitalized.pipe';

import { appTv24Icon } from '@icons/tv-24';

import { DepotOverviewCardViewModel } from './depot-overview-card.view-model';

@Component({
  selector: 'app-depot-overview-card',
  imports: [
    DepotOverviewChartComponent,
    TranslatePipe,
    VehicleOperationalStatusIconComponent,
    TranslateVehicleStatusCapitalizedPipe,
    EvseStatusIconComponent,
    TranslateEvseStatusCapitalizedPipe,
    IconButtonComponent,
    RouterLink,
  ],
  templateUrl: './depot-overview-card.component.html',
  host: {
    class:
      // eslint-disable-next-line max-len
      'flex justify-between pr-10 h-[224px] rounded-radius-cards bg-background-fixed drop-shadow-foreground-primary-20-shadow-30 dark:drop-shadow-foreground-secondary-20-shadow-30',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DepotOverviewCardComponent {
  public vm = input.required<DepotOverviewCardViewModel>();
  public siteId = input<string>();
  public gridViewEnabled = input(false);

  public readonly SiteTypeStoreModelEnum = SiteTypeStoreModelEnum;
  public readonly RouteSegment = RouteSegment;

  public statusInfo = computed(() => {
    const vm = this.vm();

    return Object.keys(vm.chartVm.data).map((untypedStatus) => {
      if (vm.type === SiteTypeStoreModelEnum.Fleet) {
        const status = untypedStatus as VehicleOperationalStatusStoreModelEnum;
        return {
          type: vm.type,
          status,
          count: vm.chartVm.data[status],
        };
      } else {
        const status = untypedStatus as EvseStatusStoreModelEnum;

        return {
          type: vm.type,
          status,
          count: vm.chartVm.data[status],
          connectorType: vm.mostCommonConnectorType,
        };
      }
    });
  });

  constructor() {
    injectRegisterIcons([appTv24Icon]);
  }
}
